import { NullAdaptor } from '@/services/analytics/adaptors/abstract';
import type { AbstractAdaptor } from '@/services/analytics/adaptors/abstract.ts';
import { GoogleAdaptor } from '@/services/analytics/adaptors/ga';
import { YandexAdaptor } from '@/services/analytics/adaptors/yandex';
import { ZeblineAdaptor } from '@/services/analytics/adaptors/zebline';

const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID;
const YANDEX_ID = import.meta.env.VITE_YANDEX_ID;
const ZEBLINE_TOKEN = import.meta.env.VITE_ZEBLINE_TOKEN;
const ZEBLINE_LICENCE_CODE = import.meta.env.VITE_ZEBLINE_LICENCE_CODE;

///// Google Analytics
let googleAnalytics: AbstractAdaptor = new NullAdaptor();

export const initializeGA = () => {
  if (GA_TRACKING_ID && !(googleAnalytics instanceof GoogleAdaptor)) {
    googleAnalytics = new GoogleAdaptor();
    googleAnalytics.init?.({ trackingId: GA_TRACKING_ID });
  }
};

///// Yandex Analytics
let yandexAnalytics: AbstractAdaptor = new NullAdaptor();

export const initializeYandex = () => {
  if (YANDEX_ID && !(yandexAnalytics instanceof YandexAdaptor)) {
    yandexAnalytics = new YandexAdaptor();
    yandexAnalytics.init?.({ trackingId: YANDEX_ID });
  }
};

///// Zebline Analytics
let zeblineAnalytics: ZeblineAdaptor = new ZeblineAdaptor();

export const initializeZebline = () => {
  if (ZEBLINE_TOKEN && ZEBLINE_LICENCE_CODE && zeblineAnalytics instanceof ZeblineAdaptor) {
    zeblineAnalytics = new ZeblineAdaptor();
    zeblineAnalytics.init({ token: ZEBLINE_TOKEN, licenceCode: ZEBLINE_LICENCE_CODE });
  }
};

export { googleAnalytics, yandexAnalytics, zeblineAnalytics };
